import { createCreateActionType } from "@multiweb/reactUtils";

/**
 * Jméno modulu menu. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "forms";

const createActionType = createCreateActionType(NAME);

/**
 * Typ akce pro inicializaci framu.
 */
export const INIT_FORM = createActionType("INIT_FORM");

/**
  * Typ akce pro smazání formu.
  */
export const DELETE_FORM = createActionType("DELETE_FORM");
